export default __webpack_public_path__ + "static/media/thumb-good.d14d35e3.svg";